import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

interface DailyMotionFormProps {
    onFieldChange: (field: string, value: string | boolean) => void;
    onFieldBlur?: (field: string, value: string | boolean) => void;
    dailyMotionFormState: DailyMotionFormState;
    disableCompilationFields?: boolean;
}

export interface DailyMotionFormState {
    title: string;
    description: string;
    is_created_for_kids: boolean;
    private: boolean;
    channel_id: string;
}

const DailyMotionForm: React.FC<DailyMotionFormProps> = ({
                                                             onFieldChange,
                                                             onFieldBlur, // Destrutturiamo la nuova prop
                                                             dailyMotionFormState,
                                                             disableCompilationFields = false
                                                         }) => {

    const handleBlur = (field: string, value: string | boolean) => {
        if (onFieldBlur) {
            onFieldBlur(field, value);
        }
    };

    return (
        <Grid container spacing={2}>
            {/* Sostituito "item md={12} lg={6}" con la nuova prop "size" */}
            <Grid size={{ md: 12, lg: 12 }}>
                <Box display="flex" flexDirection={'column'}>
                    <TextField
                        value={dailyMotionFormState.title}
                        name={"dailyMotionTitle"}
                        placeholder={"Insert dailyMotion title"}
                        type={'text'}
                        variant={'outlined'}
                        onChange={(e) => onFieldChange('title', e.target.value)}
                        onBlur={(e) => handleBlur('title', e.target.value)}
                        fullWidth
                        sx={{ mb: 2 }}
                        disabled={disableCompilationFields}
                    />
                    <TextField
                        multiline
                        minRows={6}
                        placeholder={'Type post description'}
                        label={'Description'}
                        value={dailyMotionFormState.description}
                        onChange={(e) => onFieldChange('description', e.target.value)}
                        onBlur={(e) => handleBlur('description', e.target.value)}
                        fullWidth
                        sx={{ height: '100%', display: 'flex' }}
                        disabled={disableCompilationFields}
                    />
                    <TextField
                        value={dailyMotionFormState.channel_id}
                        name={"dailyMotionChannelId"}
                        placeholder={"Insert Channel ID"}
                        type={'text'}
                        variant={'outlined'}
                        onChange={(e) => onFieldChange('channel_id', e.target.value)}
                        onBlur={(e) => handleBlur('channel_id', e.target.value)}
                        fullWidth
                        sx={{ mb: 2, mt: 2 }}
                    />
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <FormControlLabel
                            label={"Private"}
                            control={
                                <Checkbox
                                    checked={dailyMotionFormState.private || false}
                                    onChange={(e) => onFieldChange('private', e.target.checked)}
                                    onBlur={() => handleBlur('private', dailyMotionFormState.private)}
                                />
                            }
                        />
                        <FormControlLabel
                            label={"Only Children"}
                            control={
                                <Checkbox
                                    checked={dailyMotionFormState.is_created_for_kids || false}
                                    onChange={(e) => onFieldChange('is_created_for_kids', e.target.checked)}
                                    onBlur={() => handleBlur('is_created_for_kids', dailyMotionFormState.is_created_for_kids)}
                                />
                            }
                        />
                    </Box>
                </Box>
            </Grid>
        </Grid>
    )
}

export default DailyMotionForm;